import { fetchUtils } from 'admin-on-rest';

export const localClient = (url, options = {}) => {
  const opts = { ...options };
  if (!opts.headers) {
    opts.headers = new Headers({ Accept: 'application/json' });
  }
  // add your own headers here
  opts.headers.set('Authorization', 'Basic NTY1ZmY4ODQ5YTUwMDYzMjg2NzAwMjdkOmFMNDNrdDZVSWdWcnFpNVA==');
  opts.headers.set('X-User-Agent', 'pinchos/5.0 pinchos/2.0.0 Android/4.4 Google/Nexus 5hos/5.0 silentorder/2.0.0 Android/4.4 Google/Nexus 5');
  opts.headers.set('Accept-Language', 'en-US');
  return fetchUtils.fetchJson(url, opts);
};

export const kunal = (url, options = {}) => {
  const opts = { ...options };
  const token = localStorage.getItem('token');
  if (!opts.headers) {
    opts.headers = new Headers({ Accept: 'application/json' });
  }
  opts.headers.set('Authorization', `Bearer ${token}`);
  // add your own headers here
  return fetchUtils.fetchJson(url, opts);
};
